import { ActionType } from 'interfaces/generic';
import { TExternalJackpot, TJackpotMeta } from 'interfaces/jackpot';
import { JackpotActionTypes } from 'store/action-types/jackpot';

export const setCurrentJackpotId = (
  payload: Record<string, number | null>
): ActionType => {
  return {
    type: JackpotActionTypes.SET_CURRENT_JACKPOT_ID,
    payload
  };
};

export const setJackpotMetaData = (payload: {
  moduleId: string;
  jackpotId: number;
  jackpotData: TJackpotMeta[];
}): ActionType => {
  return {
    type: JackpotActionTypes.SET_JACKPOT_META_DATA,
    payload
  };
};

export const setInternalJackpots = (data: Object): ActionType => {
  return {
    type: JackpotActionTypes.SET_INTERNAL_JACKPOTS,
    payload: data
  };
};

export const setExternalJackpots = (
  payload: TExternalJackpot[] | null
): ActionType => {
  return {
    type: JackpotActionTypes.SET_EXTERNAL_JACKPOTS,
    payload
  };
};
